import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  mainDialog: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    minWidth: '991px',
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    direction: 'rtl',
  },
  footer: {
    display: 'flex',
    gap: '1rem',
  },

  badgeContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
  },

  badge: {
    borderRadius: '0.75rem',
    padding: '0.4rem 0.8rem',
    fontSize: '0.6rem',
  },
}));

export default useStyles;
